export default "/assets/images/critter-cuddler-hero.png?19edf8981e62ca0777572d3ff7c441c9";